<ng-container *ngrxLet="assistantStore.getOverlay$ | async as overlay">
  <ng-container [ngSwitch]="overlay.current">
    <ng-container *ngSwitchDefault>
      <ng-container [ngTemplateOutlet]="closeBtn"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="Overlay.FeedbacksView">
      <div class="flex gap-2">
        <app-assistant-feedback-export-list></app-assistant-feedback-export-list>
        <ng-container [ngTemplateOutlet]="closeBtn"></ng-container>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="Overlay.SearchView">
      <button
        class="overlay-btn"
        *ngIf="authStore.isAccessFeedbackApplicationRole$ | async"
        mat-stroked-button
        (click)="assistantService.changeOverlay(Overlay.FeedbacksView)"
      >
        {{ '+ASSISTANT.FEEDBACKS.HEADER' | translate }}
      </button>
    </ng-container>
  </ng-container>

  <ng-template #closeBtn>
    <button
      class="close-btn-overlay lt-md:!hidden"
      mat-stroked-button
      (click)="closeDocument(overlay.previous)"
    >
      <span>
        {{ 'GENERAL.BUTTON.CLOSE' | translate }}
      </span>
      <mat-icon iconPositionEnd>close</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="closeDocument(overlay.previous)"
      class="close-btn-small lt-md:!flex !hidden"
      gtm="onClose"
      gtmAction="Installation details overlay"
      gtmCategory="installationDetails"
    >
      <mat-icon>close</mat-icon>
    </button>
  </ng-template>
</ng-container>
